const Chip = ({ value, variant = 'filled', color = 'blue', small = false, disabled = false }) => {
    const colors = {
        blue: {
            filled: {
                backgroundColor: '#29abe233',
                color: '#146c91',
                border: '1px solid #29abe2',
                hoverBackgroundColor: '#0056b3',
                hoverColor: '#fff',
                hoverBorder: '1px solid #0056b3',
            },
            outlined: {
                backgroundColor: 'transparent',
                color: '#007bff',
                border: '1px solid #007bff',
                hoverBackgroundColor: '#007bff',
                hoverColor: '#fff',
                hoverBorder: '1px solid #007bff',
            },
        },
        red: {
            filled: {
                backgroundColor: '#cb383726',
                color: '#bc3433',
                border: '1px solid #bc3433',
                hoverBackgroundColor: '#a71d2a',
                hoverColor: '#fff',
                hoverBorder: '1px solid #a71d2a',
            },
            outlined: {
                backgroundColor: 'transparent',
                color: '#dc3545',
                border: '1px solid #dc3545',
                hoverBackgroundColor: '#dc3545',
                hoverColor: '#fff',
                hoverBorder: '1px solid #dc3545',
            },
        },
        green: {
            filled: {
                backgroundColor: '#28a74530',
                color: '#00af00',
                border: '1px solid #28a745',
                hoverBackgroundColor: '#1e7e34',
                hoverColor: '#fff',
                hoverBorder: '1px solid #1e7e34',
            },
            outlined: {
                backgroundColor: 'transparent',
                color: '#28a745',
                border: '1px solid #28a745',
                hoverBackgroundColor: '#28a745',
                hoverColor: '#fff',
                hoverBorder: '1px solid #28a745',
            },
        },
        yellow: {
            filled: {
                backgroundColor: '#ffcd3a33',
                color: '#886701',
                border: '1px solid #ffcd3a',
                hoverBackgroundColor: '#1e7e34',
                hoverColor: '#fff',
                hoverBorder: '1px solid #1e7e34',
            },
            outlined: {
                backgroundColor: 'transparent',
                color: '#28a745',
                border: '1px solid #28a745',
                hoverBackgroundColor: '#28a745',
                hoverColor: '#fff',
                hoverBorder: '1px solid #28a745',
            },
        },
        magenta: {
            filled: {
                backgroundColor: '#c836c333',
                color: '#782075',
                border: '1px solid #c836c3',
                hoverBackgroundColor: '#1e7e34',
                hoverColor: '#fff',
                hoverBorder: '1px solid #1e7e34',
            },
            outlined: {
                backgroundColor: 'transparent',
                color: '#28a745',
                border: '1px solid #28a745',
                hoverBackgroundColor: '#28a745',
                hoverColor: '#fff',
                hoverBorder: '1px solid #28a745',
            },
        },
        purple: {
            filled: {
                backgroundColor: '#8956ff33',
                color: '#290089',
                border: '1px solid #8956ff',
                hoverBackgroundColor: '#1e7e34',
                hoverColor: '#fff',
                hoverBorder: '1px solid #1e7e34',
            },
            outlined: {
                backgroundColor: 'transparent',
                color: '#28a745',
                border: '1px solid #28a745',
                hoverBackgroundColor: '#28a745',
                hoverColor: '#fff',
                hoverBorder: '1px solid #28a745',
            },
        },
        inactive: {
            filled: {
                backgroundColor: 'rgba(234, 142, 142, 0.2)',
                color: 'rgba(234, 142, 142, 1)',
                border: '1px solid rgba(234, 142, 142, 1)',
                hoverBackgroundColor: '#1e7e34',
                hoverColor: '#fff',
                hoverBorder: '1px solid #1e7e34',
            },
            outlined: {
                backgroundColor: 'transparent',
                color: '#28a745',
                border: '1px solid #28a745',
                hoverBackgroundColor: '#28a745',
                hoverColor: '#fff',
                hoverBorder: '1px solid #28a745',
            }
        }
    };

    const selectedVariant = colors[color]?.[variant] || colors.blue.filled;

    return (
        <span
            // className="flex items-center flex-shrink-0 w-fit justify-center px-4 py-0.5 rounded-full cursor-pointer transition duration-300 ease-in-out"
            className={`inline-block px-4 py-0.5 rounded-full border text-xs font-semibold capitalize`}
            style={{
                backgroundColor: selectedVariant.backgroundColor,
                color: selectedVariant.color,
                border: selectedVariant.border,
                textTransform: 'capitalize',
                fontWeight: 700,
                fontSize: small ? '0.6rem' : '0.75rem',
                opacity: disabled ? 0.5 : 1,
            }}
            // onMouseEnter={(e) => {
            //     e.target.style.backgroundColor = selectedVariant.hoverBackgroundColor;
            //     e.target.style.color = selectedVariant.hoverColor;
            //     e.target.style.border = selectedVariant.hoverBorder;
            // }}
            // onMouseLeave={(e) => {
            //     e.target.style.backgroundColor = selectedVariant.backgroundColor;
            //     e.target.style.color = selectedVariant.color;
            //     e.target.style.border = selectedVariant.border;
            // }}
        >
            <span>{value}</span>
        </span>
    );
};

export default Chip;